import { RouteVia, RouteViaLabels } from "../../../../enums/routeVia";
import {
  SubmissionSummaryRouteVia,
  SubmissionSummaryRouteViaLabels,
} from "../../../../enums/submissionSummaryRouteVia";

// pa_request_entries.route_via mixes BOTH vocabularies (confirmed against live
// BQ data): NYCBS/CMM-tracking writes "cmm"/"CMM"/"Form Only"/"Evicore"/
// "EOC ID"/"Missing Prescription"/"Medical Benefit"/"Self Pay"/"Others"
// (SubmissionSummaryRouteVia), while other pharmacy submission flows write
// "FaxPA"/"PromptPA"/"PhonePA"/"Surescripts" (RouteVia, same enum the sibling
// pharmaPrimaryCare/pharmaOncologySubmission/asteraOncologyExternal tables use
// for this column). The filter must offer both sets. "cmm" and "CMM" are
// listed as separate exact-match options -- the backend filter is a
// case-sensitive exact match (same precedent as pharmaPrimaryCare's
// routeViaFilterOptions.ts) and both casings appear in real data.
// RouteVia.OTHERS and SubmissionSummaryRouteVia.OTHERS both resolve to the
// same value/label ("Others") -- excluded from the second loop the same way
// CMM is, so it isn't listed twice.
export const allRouteViaOptions = [
  { label: "cmm", value: RouteVia.CMM },
  { label: "CMM", value: "CMM" },
  ...Object.values(RouteVia)
    .filter((routeVia) => routeVia !== RouteVia.CMM)
    .map((routeVia) => ({ label: RouteViaLabels[routeVia], value: routeVia })),
  ...Object.values(SubmissionSummaryRouteVia)
    .filter(
      (routeVia) =>
        routeVia !== SubmissionSummaryRouteVia.CMM &&
        routeVia !== SubmissionSummaryRouteVia.OTHERS,
    )
    .map((routeVia) => ({
      label: SubmissionSummaryRouteViaLabels[routeVia],
      value: routeVia,
    })),
];
